import React from 'react'
import styled from 'styled-components';

function Input({
    label,
    name = "input",
    isDisabled,
    register,
    required = {},
    error,
    ...inputProps }) {
    return (
        <Wrapper>
            {label &&
                <Label>{label}</Label>
            }
            <InputBox {...register(name, required)} {...inputProps} disabled={isDisabled}></InputBox>
            <Error>{error?.message}</Error>
        </Wrapper>
    )
}

export default Input;


const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: spacing(1) 0 spacing(1) 0;
    width: 100%;
    margin: 8px 0;
`;
const Label = styled.label`
    padding: 8px 24px;
`;

const InputBox = styled.input`
    background-color: var(--color-gris-claro);
    color: var(--color-negro);
    border: 3px solid var(--color-blanco);
    border-radius: 10px;
    height: 40px;
    width: 90%;
    padding: 0 16px;
    align-self: center;

    .disabledd{
        color:var(--color-morad);
    }

    &::placeholder {
        color: var(--color-gris-oscuro);
    }

    &:focus {
        border: 3px solid var(--color-morado-claro);
        outline: none;
    }

`;
const Error = styled.span`
    font-size: .8em;
    padding: spacing(1);
    color: var(--color-error);
    margin-left: 24px;
`;